
/*@stayai:
Check if the "Step 1: Pick your pack" label is visible. If so, attach "Step 2: Purchase Options" label above the Stay Widget to maintain visual consistency.
*/
const SELECTORS = {
  'step1-label': '.sibling-selector > .sibling-selector__container > label.sibling-selector__label',
  'stay-widget': 'purchase-options div.is-visible.stayai-subscriptions'
}

let mainProductObserver = null
let isApplying = false
let debounceTimer = null

function applyStep2Label() {
  if (document.querySelector('.step2-label') || isApplying) return // Already exists or in progress

  isApplying = true
  const step1Label = document.querySelector(SELECTORS['step1-label'])
  const stayWidget = document.querySelector(SELECTORS['stay-widget'])
  if (!step1Label || !stayWidget) {
    isApplying = false
    return
  }

  const newStep2Label = step1Label.cloneNode(true)
  newStep2Label.textContent = 'Step 2: Purchase options'
  newStep2Label.className += ' step2-label'
  newStep2Label.style.marginTop = '1rem'
  stayWidget.insertBefore(newStep2Label, stayWidget.firstChild)
  isApplying = false
}

function setupMainProductWatcher() {

  // Disconnect existing observer if any
  if (mainProductObserver) {
    mainProductObserver.disconnect()
    mainProductObserver = null
  }

  const mainProduct = document.querySelector('[data-section-type="main-product"]')
  if (!mainProduct || !mainProduct.parentNode) return

  // Watch for when main-product section is replaced by product-sibling-selector.js
  mainProductObserver = new MutationObserver(() => {
    const currentMainProduct = document.querySelector('[data-section-type="main-product"]')
    if (currentMainProduct && currentMainProduct !== mainProduct) {
      // Debounce to prevent multiple rapid executions
      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(() => {

        requestAnimationFrame(() => {
          Promise.all([
            elementReady(SELECTORS['step1-label'], 5000),
            elementReady(SELECTORS['stay-widget'], 5000)
          ]).then(() => {
            applyStep2Label()
            // Re-setup watcher for the new main-product
            setupMainProductWatcher()
          }).catch(() => {})
        })
      }, 400) // Debounce delay
    }
  })

  // Watch the parent of main-product for child replacement
  mainProductObserver.observe(mainProduct.parentNode, { childList: true })
}

// Initial application
Promise.all([
  elementReady(SELECTORS['step1-label']),
  elementReady(SELECTORS['stay-widget'])
]).then(() => {
  applyStep2Label()
  setupMainProductWatcher()
}).catch((error) => {
  console.warn('StayAI PDP: Could not initialize step labels:', error.message)
})

// Also listen for DOMContentLoaded (dispatched after DOM replacement in product-sibling-selector.js line 122)
let domContentLoadedHandled = false
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.step2-label') || domContentLoadedHandled) return
  domContentLoadedHandled = true

  requestAnimationFrame(() => {
    setTimeout(() => {
      Promise.all([
        elementReady(SELECTORS['step1-label'], 5000),
        elementReady(SELECTORS['stay-widget'], 5000)
      ]).then(() => {
        applyStep2Label()
        setupMainProductWatcher()
        domContentLoadedHandled = false // Reset after handling
      }).catch(() => {
        domContentLoadedHandled = false
      })
    }, 400) // Wait for replacement animation to complete (300ms + buffer)
  })
})

// helper
function elementReady(selector, timeout = 10000) {
  const el = document.querySelector(selector)
  if (el) return Promise.resolve(el)

  return new Promise((resolve, reject) => {
    const observer = new MutationObserver(() => {
      const found = document.querySelector(selector)
      if (found) {
        clearTimeout(timeoutId)
        observer.disconnect()
        resolve(found)
      }
    })
    const timeoutId = setTimeout(() => {
      observer.disconnect()
      reject(new Error(`Element not found: ${selector} (timeout after ${timeout}ms)`))
    }, timeout)
    observer.observe(document.documentElement, { childList: true, subtree: true })
  })
}





